<template>
  <v-dialog
    persistent
    v-model="get_dialogMain.dialog"
    width="1200px"
    justify-center
  >
    <v-toolbar dense dark color="blue darken-2">
      <v-toolbar-title>
        <h3>{{model.customer.NombreCompleto}}</h3>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon dark @click="HIDDE_DIALOG_MAIN()">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>
    <!-- <PrecalificacionForm :model="credit" :on-cancel="cancel" /> -->
    <CreditoForm :model="model" :on-cancel="cancel" :ResendEmail="Resend"/>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
// import PrecalificacionForm from '@/components/forms/PrecalificacionForm'
import CreditoForm from '@/components/forms/CreditoForm'
export default {
  props: ['model'],
  data: () => ({
    showProgressEmail: false,
    credit: {
      creditInfonavit: 0
    }
  }),
  mounted () {
    if (this.model.id) {
      this.credit = Object.assign({}, this.model)
    }
  },
  components: {
    // PrecalificacionForm,
    CreditoForm
  },
  methods: {
    ...mapActions(['postCompanys', 'postResendEmailPrecalificacion']),
    cancel () {
      this.HIDDE_DIALOG_MAIN()
    },
    Resend (model) {
      // console.log('model', model)
      this.postResendEmailPrecalificacion(model)
    },
    ...mapMutations(['HIDDE_DIALOG_MAIN', 'SET_PROGRESS_EMAIL'])
  },
  computed: {
    ...mapGetters(['get_dialogMain', 'get_company', 'get_emailSend'])
  },
  watch: {
    get_company (val) {
      if (val.message) {
        this.$swal({
          type: 'error',
          icon: 'error',
          title: 'Error!',
          text: val.message
        })
        return
      }
      this.$swal({
        type: 'success',
        icon: 'success',
        title: 'Exitoso!',
        text: 'Empresa ha sido creado'
      })
      this.cancel()
    },
    get_emailSend (val) {
      if (val.message) {
        this.$swal({
          type: 'error',
          icon: 'error',
          title: 'Error!',
          text: val.message
        })
        return
      }
      this.SET_PROGRESS_EMAIL(false)
      this.$swal({
        type: 'success',
        icon: 'success',
        title: 'Exitoso!',
        text: 'Correo Re-enviado correctamente'
      })
    }
  }
}
</script>

<style></style>
